import { useState, useEffect, useRef } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { useAuth } from "../../context/Auth";
import { NavbarArrowDownIcon } from "../../icons/Icon";

const Selection = ({
  label,
  options,
  dropDownText,
  star,
  value,
  onchange,
  disableOpen = false,
  collapseDuplicates = false,
}) => {
  const { mode } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const dropdownRef = useRef(null);

  const handleOptionSelect = (option) => {
    const isSelected = selectedOptions.some(
      (item) => item.value === option.value
    );
    const newSelection = isSelected
      ? selectedOptions.filter((item) => item.value !== option.value)
      : [...selectedOptions, option];

    setSelectedOptions(newSelection);
    setTimeout(() => {
      onchange(newSelection);
    }, 0);
  };

  const openSelector = () => {
    if (!disableOpen) setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    setSelectedOptions(value || []);
  }, [value]);

  const triggerStyles = {
    backgroundColor: mode && "#1b1d21",
    borderColor: mode && "#1b1d21",
    cursor: disableOpen ? "text" : "pointer",
  };
  const listStyles = {
    backgroundColor: mode && "#232529",
    borderColor: mode && "#232529",
  };

  return (
    <div className={styles.container} ref={dropdownRef}>
      {label && (
        <label
          className={styles.dropdown_label}
          style={{ color: mode && "#fff" }}
        >
          {label}
          {star && <span>*</span>}
        </label>
      )}

      <div className={styles.select} style={{ borderColor: mode && "#1b1d21" }}>
        <div
          className={styles.trigger}
          style={triggerStyles}
          onClick={openSelector}
        >
          <div className={styles.placeholder}>
            <span style={{ color: mode && "#FFFFFF" }}>
              {selectedOptions.length > 0 ? (
                (() => {
                  const labels = selectedOptions.map((opt) => opt.label);

                  if (collapseDuplicates) {
                    const allSame = labels.every(
                      (label) => label === labels[0]
                    );
                    return allSame ? labels[0] : labels.join(", ");
                  }

                  return labels.join(", ");
                })()
              ) : (
                <span style={{ color: "#9C9797" }}>{dropDownText}</span>
              )}
            </span>

            {!disableOpen && (
              <NavbarArrowDownIcon color={mode ? "#FFFFFF" : "#646B88"} />
            )}
          </div>
        </div>

        {isOpen && (
          <ul className={styles.list} style={listStyles}>
            {options?.map((option, index) => {
              const isSelected = selectedOptions?.some(
                (o) => o.value === option.value
              );
              return (
                <li
                  key={index}
                  className={`${styles.item} ${mode ? styles.item_dark : ""}`}
                  onClick={() => handleOptionSelect(option)}
                >
                  {option.label}
                  {isSelected && <span>✓</span>}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Selection;
